// Every caller does `${API_BASE_URL}v1/foo` — i.e. string-concatenation
// without an interceding slash. If the env var is set to a URL WITHOUT a
// trailing `/` (a deploy-time typo we've hit in production), the result is
// `https://host/serverv1/foo` instead of `https://host/server/v1/foo`,
// which nginx then rewrites to `/foo` (eating the `v1`), the route doesn't
// exist, and the CSRF middleware (which runs before route matching) returns
// a misleading 403 "Invalid CSRF token". So: force the trailing slash and
// warn in dev so the misconfiguration is caught early.
function normalizeBase(raw, fallback) {
  const v = raw && raw.trim() ? raw.trim() : fallback;
  const fixed = v.endsWith("/") ? v : v + "/";
  if (fixed !== v && typeof console !== "undefined") {
    // eslint-disable-next-line no-console
    console.warn(
      `[config] API base URL was missing trailing slash — normalized "${v}" → "${fixed}". Set REACT_APP_API_BASE_URL with a trailing "/" to silence this warning.`,
    );
  }
  return fixed;
}

export const API_BASE_URL = normalizeBase(
  process.env.REACT_APP_API_BASE_URL,
  "http://localhost:8003/",
);

// Boards service (smarthatch-boards-service). Standalone Node service —
// shares the login-system's JWT cookie (`urltoken`) via the same domain in
// dev (different ports on localhost are cookie-shareable) and via a sibling
// subdomain in prod.
export const BOARDS_API_BASE_URL = normalizeBase(
  process.env.REACT_APP_BOARDS_API_BASE_URL,
  "http://localhost:8004/",
);